import React from "react";
import CheckBox from "../components/Checkbox";
import Carousel from "../components/Carousel";
import Projects from "../components/Home/Projects";
import HomePageBanner from "../components/Home/HomePageBanner";
import StatsSection from "../components/StatsSection";
import ModernCTA from "../components/ModernCTA";

function HomePage() {

  const images = [
    { 
      src: "img1.jpg", 
      title: "Building the Future", 
      description: "Excellence in construction with a focus on sustainable and innovative designs. Our projects shape the skyline and redefine urban spaces for future generations.", 
    },
    { 
      src: "img2.jpg",
      title: "Engineering Landmarks", 
      description: "Reliable and sustainable projects that stand as symbols of quality and precision engineering. From bridges to skyscrapers, we deliver lasting value.", 
    },
    { 
      src: "img4.jpg", 
      title: "Innovative Infrastructure", 
      description: "Delivering high-quality developments that push the boundaries of engineering and architecture. We are at the forefront of creating modern infrastructure solutions.", 
    },
    { 
      src: "img5.jpg", 
      title: "Constructing Tomorrow", 
      description: "Commitment to precision and durability in every phase of the project. Our expertise ensures that each structure is built to last, reflecting our dedication to excellence."
      },
  ];
  
  
  return (
    <>
      <Carousel images={images} />
      <StatsSection />
      <CheckBox />
      <Projects />
      <HomePageBanner />
      <ModernCTA />
    </>
  );
}

export default HomePage;
